module.exports = __webpack_public_path__ + "img/sensors-and-actuators.4d411211.jpg";